import React, { useEffect, useRef, useState } from 'react'
import HoverImageComponent from './HoverImageComponent';
import { Link } from 'react-router-dom';

const SecondComp = () => {
  const imageSets = [
    [
      require("../assets/logo1.png"),
      require("../assets/logo2.png"),
      require("../assets/logo3.png"),
      require("../assets/logo4.png"),
      require("../assets/logo5.png"),
      require("../assets/logo6.png"),
      require("../assets/logo7.png"),
      require("../assets/logo8.png"),
      require("../assets/logo9.png"),
    ],
    [require("../assets/logo2.png")],
    [require("../assets/logo3.png")],
    [require("../assets/logo4.png")],
    [require("../assets/logo5.png")],
    [
      require("../assets/websitePort.png"),
      require("../assets/WebLandingPage.png"),
      require("../assets/TBMovingandStorageLogoConcept.png"),
      require("../assets/TBMovingandStorageLogoConcept.png"),
    ],
  ];
  const imageSetsWebsite = [
    [
      require("../assets/website1.png"),
      // require("../assets/website2.png"),
      // require("../assets/website3.png"),
      // require("../assets/website4.png"),
      // require("../assets/website5.png"),
    ],
    [require("../assets/website2.png")],
    [require("../assets/website3.png")],
    [require("../assets/website4.png")],
    [require("../assets/website5.png")],
  ];
  const imageSetsStationary = [
    [
      require("../assets/stationary1.png"),
      require("../assets/stationary2.png"),
      require("../assets/stationary3.png"),
      require("../assets/stationary4.png"),
      require("../assets/stationary5.png"),
    ],
    [require("../assets/stationary2.png")],
    [require("../assets/stationary3.png")],
    [require("../assets/stationary4.png")],
    [require("../assets/stationary5.png")],
  ];
 // Create an array of refs for each image
 const scrollSmoothly = (targetElement) => {
  const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;
  const duration = 2000; // Adjust duration (in ms) for slower scrolling
  let startTime = null;

  const scrollAnimation = (currentTime) => {
    if (!startTime) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) {
      requestAnimationFrame(scrollAnimation);
    }
  };

  requestAnimationFrame(scrollAnimation);
};

const easeInOutQuad = (t, b, c, d) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

const scrollTargets = useRef([]);

const handleHover = (index) => {
  const targetElement = scrollTargets.current[index]?.current;
  if (targetElement) {
    scrollSmoothly(targetElement);
  }
};


   
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentSet, setCurrentSet] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Open popup with specific image set and index
  const openPopup = (images, index) => {
    setCurrentSet(images);
    setCurrentIndex(index);
    setIsPopupOpen(true);
  };

  // Close popup
  const closePopup = () => {
    setIsPopupOpen(false);
    setCurrentSet([]);
    setCurrentIndex(0);
  };

  // Navigate logos
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % currentSet.length);
  };

  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + currentSet.length) % currentSet.length
    );
  };
  
  return (
    <>
      <section
        className="teals-testimonials teals-testimonials-new-sec"
        id="price-plans-section"
      >
        <div className="container shadow">
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="testimonial-title text-box">
                <h3>Best of Your work</h3>
                <h2>Latest Project</h2>
              </div>
            </div>
            <div className="col-lg-8">
              <ul className="nav nav-tabs d-lg-flex" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="home-tab09"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane09"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane09"
                    aria-selected="true"
                  >
                    Logo Designs
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab08"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane08"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane08"
                    aria-selected="false"
                  >
                    Websites
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab07"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane07"
                    type="button"
                    role="tab"
                    aria-controls="profile-tab-pane07"
                    aria-selected="false"
                  >
                    Stationary
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab06"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane06"
                    type="button"
                    role="tab"
                    aria-controls="#profile-tab-pane06"
                    aria-selected="false"
                  >
                    Branding
                  </button>
                </li>

                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="profile-tab05"
                    data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane05"
                    type="button"
                    role="tab"
                    aria-controls="#profile-tab-pane05"
                    aria-selected="false"
                  >
                    Digital Marketing
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-lg-12">
              {/* WEBSITE PRICE PLAN SECTION */}
              <div className="tab-content accordion ghm" id="myTabContent">
                <div
                  className="tab-pane fade show active accordion-item"
                  id="home-tab-pane09"
                  role="tabpanel"
                  aria-labelledby="home-tab09"
                  tabindex="0"
                >
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show  d-lg-block"
                    aria-labelledby="headingOne"
                    data-bs-parent="#myTabContent"
                  >
                    <div className="container">
                      <div className="row gallery align-items-center">
                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                        <div onClick={() => openPopup(imageSets[0], 0)}>
                <HoverImageComponent images={imageSets[0]} />
              </div>
                        </div>

                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <div className="row" style={{ gap: "20px 0px" }}>
                          <div className="col-lg-6 col-6">
                          <div onClick={() => openPopup(imageSets[1], 0)}>
                <HoverImageComponent images={imageSets[1]} />
              </div>
              </div>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSets[2], 0)}>
                <HoverImageComponent images={imageSets[2]} />
              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSets[3], 0)}>
                            <HoverImageComponent images={imageSets[3]} />
                            </div>
                            </div>
                            
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSets[4], 0)}>
                            <HoverImageComponent images={imageSets[4]} />
                            </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="custom-price-button"
                          style={{ paddingTop: "70px" }}
                        >
                         <Link to ="/contact-us"><button>Get Started</button></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* WEBSITE PRICE SECTION END */}
 {/* Popup Modal */}

              {/* LOGOS PRICE PLAN Start */}
              <div
                className="tab-pane fade accordion-item prr"
                id="profile-tab-pane08"
                role="tabpanel"
                aria-labelledby="profile-tab08"
                tabindex="0"
              >
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse d-lg-block"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#myTabContent"
                >
                    <div className="container">
                      <div className="row gallery align-items-center">
                        <div className="col-sm-12 col-lg-6 mt-5 col-12 mainimage">
                        
                        <div
        className="image-container"
        onMouseEnter={() => handleHover(0)}
        ref={scrollTargets.current[0]}
      >
        <HoverImageComponent images={imageSetsWebsite[0]} />
      </div>
                        </div>

                        <div className="col-sm-12 col-lg-6 mt-5 col-12 galleryimages">
                          <div className="row" style={{ gap: "20px 0px" }}>
                          {imageSetsWebsite.slice(1).map((images, index) => (
          <div
            key={index + 1}
            className="col-lg-6 col-6 image-container"
            onMouseEnter={() => handleHover(index + 1)}
            ref={scrollTargets.current[index + 1]}
          >
            <HoverImageComponent images={images} />
          </div>
        ))}
                          </div>
                        </div>

                        <div
                          className="custom-price-button"
                          style={{ paddingTop: "70px" }}
                        >
                          <Link to ="/contact-us"><button>Get Started</button></Link>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              {/* LOGOS PRICE PLAN END */}

              {/* BRANDING PRICE PLAN Start */}
              <div
                className="tab-pane fade accordion-item prr"
                id="profile-tab-pane07"
                role="tabpanel"
                aria-labelledby="profile-tab07"
                tabindex="0"
              >
                  <div
                  id="collapseTwo"
                  className="accordion-collapse collapse d-lg-block"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#myTabContent"
                >
                  <div className="container">
                      <div className="row gallery align-items-center">
                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                        <div onClick={() => openPopup(imageSetsStationary[0], 0)}>
                <HoverImageComponent images={imageSetsStationary[0]} />
              </div>
                        </div>

                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <div className="row" style={{ gap: "20px 0px" }}>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSetsStationary[1], 0)}>
                <HoverImageComponent images={imageSetsStationary[1]} />
              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSetsStationary[2], 0)}>
                <HoverImageComponent images={imageSetsStationary[2]} />
              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSetsStationary[3], 0)}>
                <HoverImageComponent images={imageSetsStationary[3]} />
              </div>
                            </div>
                            <div className="col-lg-6 col-6">
                            <div onClick={() => openPopup(imageSetsStationary[4], 0)}>
                <HoverImageComponent images={imageSetsStationary[4]} />
              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className="custom-price-button"
                          style={{ paddingTop: "70px" }}
                        >
                          <Link to ="/contact-us"><button>Get Started</button></Link>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              {/* BRANDING PRICE PLAN END  */}

              {/* Social Media Marketing PRICE PLAN Start */}
              <div
                className="tab-pane fade accordion-item prr"
                id="profile-tab-pane06"
                role="tabpanel"
                aria-labelledby="profile-tab06"
                tabindex="0"
              >
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse d-lg-block"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#myTabContent"
                >
                  <div className="container">
                      <div className="row gallery align-items-center">
                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <img src={require("../assets/branding1.png")} />
                        </div>

                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <div className="row" style={{ gap: "20px 0px" }}>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/branding2.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/branding3.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/branding4.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/branding5.png")}
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          className="custom-price-button"
                          style={{ paddingTop: "70px" }}
                        >
                         <Link to ="/contact-us"><button>Get Started</button></Link>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div
                className="tab-pane fade accordion-item prr"
                id="profile-tab-pane05"
                role="tabpanel"
                aria-labelledby="profile-tab05"
                tabindex="0"
              >
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse d-lg-block"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#myTabContent"
                >
                   <div className="container">
                      <div className="row gallery align-items-center">
                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <img src={require("../assets/logo1.png")} />
                        </div>

                        <div className="col-sm-12 col-lg-6 mt-5 col-12">
                          <div className="row" style={{ gap: "20px 0px" }}>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/logo2.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/logo3.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/logo4.png")}
                              />
                            </div>
                            <div className="col-lg-6 col-6">
                              <img
                                src={require("../assets/logo5.png")}
                              />
                            </div>
                          </div>
                        </div>

                        <div
                          className="custom-price-button"
                          style={{ paddingTop: "70px" }}
                        >
                          <Link to ="/contact-us"><button>Get Started</button></Link>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
         
        </div>
      </section>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-button" onClick={closePopup}>
              ✖
            </button>
            <img
              src={currentSet[currentIndex]}
              alt="Logo"
              className="popup-image"
            />
            <div className="popup-controls">
              <button onClick={handlePrevious}>&larr; </button>
              <button onClick={handleNext}> &rarr;</button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SecondComp
